import { useLanguage } from '../context/LanguageContext';

/**
 * 🟪 P25.5 · LanguageSelector — versión compacta en mobile.
 *
 * Comportamiento (owner mandate 2026-02):
 *   • Desktop (≥640px): sigue mostrando 🇪🇸 / 🇺🇸 con opacidades
 *     (idioma activo con opacidad plena, el otro atenuado).
 *   • Mobile (<640px): muestra UNA sola bandera — la del idioma AL
 *     QUE puedes cambiar (para reducir el ancho a la mitad y evitar
 *     que el botón quede debajo del toggle Claro/Oscuro):
 *       - Si idioma = 'es' → 🇺🇸 (USA)
 *       - Si idioma = 'en' → 🇨🇺 (Cuba)
 *
 * Nada se borra: el mismo botón, mismo onClick, mismo data-testid.
 * Solo cambia lo que se ve dentro según el viewport.
 */
const LanguageSelector = ({ className = '' }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-1 px-2 py-1.5 bg-zinc-800/50 hover:bg-zinc-700/50 border border-zinc-700/50 rounded-lg transition-all ${className}`}
      data-testid="language-selector"
      title={language === 'es' ? 'Change to English' : 'Cambiar a Español'}
    >
      {/* Mobile: una sola bandera (la del idioma al que se puede cambiar) */}
      <span
        className="text-sm sm:hidden"
        data-testid="language-selector-mobile-flag"
        aria-hidden="true"
      >
        {language === 'es' ? '🇺🇸' : '🇨🇺'}
      </span>

      {/* Desktop: comportamiento clásico ES / US con opacidades */}
      <span
        className={`hidden sm:inline text-sm ${language === 'es' ? 'opacity-100' : 'opacity-40'}`}
      >
        🇪🇸
      </span>
      <span className="hidden sm:inline text-zinc-600 text-xs">/</span>
      <span
        className={`hidden sm:inline text-sm ${language === 'en' ? 'opacity-100' : 'opacity-40'}`}
      >
        🇺🇸
      </span>
    </button>
  );
};

export default LanguageSelector;
